import React, { useState } from 'react';
import styled from 'styled-components/macro';
// components
import { PrimaryButton } from 'components/PrimaryButton';
import { ModalVideoCTA } from 'components/modals/ModalVideoCTA';
// types
import { CTAButtonsValues, PlaybackData } from 'types';
// queries
import { useCreateStatsLinksMutation } from 'queries/stats/createStatsLinksMutation';
import { PlaybackDetailsResponse } from 'queries/details/usePlaybackDetailsQuery';

type WrapperProps = {
  width: string;
};
const Wrapper = styled.div<WrapperProps>`
  box-sizing: border-box;
  padding: 0 20px 20px;
  width: ${({ width }) => width};
  max-width: 100%;
  display: flex;
  justify-content: center;
  gap: 15px;
  flex-wrap: wrap;
  @media screen and (max-width: 520px) {
    padding: 0 0 20px;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

const PrimaryButtonStyled = styled(PrimaryButton)`
  min-width: 31%;
  @media screen and (max-width: 520px) {
    width: 100%;
  }
`;

type Props = {
  ctaSetData: any;
  color: string;
  width: string;
  viewerStatisticId: number;
  videoId: number;
  shortUrl: string;
  playbackData?: PlaybackData | PlaybackDetailsResponse;
};

export const CtaButtons = ({
  ctaSetData,
  width,
  viewerStatisticId,
  shortUrl,
  playbackData,
}: Props) => {
  const { mutate: createStatsLinksMutation } = useCreateStatsLinksMutation();
  const [showCtaVideoModal, setShowCtaVideoModal] = useState(0);
  if (!ctaSetData || ctaSetData.id <= 0 || !ctaSetData?.links?.length) {
    return null;
  }

  const onCtaClick = (ctaItem: any) => {
    // save click to stats links
    const statsLink = {
      viewerStatisticId: viewerStatisticId || -1,
      linksetId: ctaItem.ctaSetId || -1,
      designId: -2,
      linkId: ctaItem.id || -1,
    };
    createStatsLinksMutation({ data: statsLink, shortUrl });

    if (ctaItem.itemType === 'video' || ctaItem.type === 'video') {
      setShowCtaVideoModal(ctaItem.id);
    } else {
      window.open(ctaItem.linkValue, '_blank');
    }
  };

  return (
    <Wrapper width={width}>
      {ctaSetData.links
        .filter((link: any) => !!link.linkText)
        .map((ctaItem: any, index: number) => {
          return (
            <React.Fragment key={index}>
              <PrimaryButtonStyled
                borderRadius={5}
                center={true}
                isFullWidth={true}
                height={'40px'}
                textPadding={'0 12px'}
                iconPadding={'0px'}
                text={ctaItem.linkText}
                iconOpacity={1}
                backgroundColor={
                  playbackData?.playerDesign.playerBackgroundColor || 'white'
                }
                textColor={
                  playbackData?.playerDesign.playerIconsAndTextColor ||
                  'inherit'
                }
                onClick={() => onCtaClick(ctaItem)}
                fontWeight={600}
                fontSize={15}
                width={'auto'}
              />
              {(ctaItem.itemType === CTAButtonsValues.VIDEO ||
                ctaItem.type === CTAButtonsValues.VIDEO) &&
                showCtaVideoModal === ctaItem.id && (
                  <ModalVideoCTA
                    handleCloseModal={() => setShowCtaVideoModal(0)}
                    videoSource={ctaItem.linkValue}
                  />
                )}
            </React.Fragment>
          );
        })}
    </Wrapper>
  );
};
